import { Route, Switch } from 'react-router-dom';
import SnackbarProvider from 'react-simple-snackbar';
import { NotFoundPage } from '../components/NotFoundPage';
import SystemNotification from '../components/Notifications/SystemNotifications';
import PrivateRoute from '../components/PrivateRoute/PrivateRoute';
import { NewProposal } from '../components/Proposal/NewProposal';
import ProposalBrief from '../components/Proposal/ProposalBrief';
import CampaignList from './CampaignPage/CampaignList';
import CreateCampaignPage from './CampaignPage/CreateCampaignPage';
import CampaignAuditPage from './CampaignAuditPage/CampaignAuditPage';
import CreativityPublicView from './CreativityPublicView/CreativityPublicView';
import DashboardPage from './DashboardPage/DashboardPage';
import DashboardPageIndividual from './DashboardPage/DashboardPageIndividual';
import ForgotPassword from './ForgotPassword/ForgotPassword';
import LoginPage from './LoginPage/LoginPage';
import Management from './Management/Management';
import CampaignProposalsList from './Proposals/CampaignProposalsList';
import ResetPassword from './ResetPassword/ResetPassword';
import ScreenApproval from './ScreenApproval/ScreenApproval';
import UploadTesterPage from './UploadTesterPage/UploadTesterPage';
import { useAuth } from './UseAuth';

function App() {
    const auth = useAuth();
    const session = auth.session;

    return (
        <>
            <SystemNotification />
            <SnackbarProvider>
                <Switch>
                    <Route
                        exact
                        path="/commercial"
                        component={() => {
                            window.location.href =
                                process.env.REACT_APP_WL_COMPANY_URL;
                            return LoginPage();
                        }}
                    />
                    <Route exact path="/forgot" component={ForgotPassword} />
                    <Route exact path="/reset" component={ResetPassword} />
                    {session && 'token' in session ? (
                        <Route exact path="/" component={DashboardPage}></Route>
                    ) : (
                        <Route exact path="/" component={LoginPage}></Route>
                    )}
                    <Route
                        exact
                        path="/upload-tester"
                        component={UploadTesterPage}
                    />
                    <PrivateRoute exact path="/dashboard">
                        <DashboardPage />
                    </PrivateRoute>
                    {/* <PrivateRoute exact path="/campaign">
                            <DashboardPage/>
                        </PrivateRoute> */}
                    <PrivateRoute exact path="/dashboard/:id">
                        <DashboardPageIndividual />
                    </PrivateRoute>
                    <PrivateRoute exact path="/dashboard/:id/audit">
                        <CampaignAuditPage />
                    </PrivateRoute>
                    <PrivateRoute exact path="/campaign/new">
                        <CreateCampaignPage />
                    </PrivateRoute>
                    <PrivateRoute exact path="/campaign/edit/:id">
                        <CreateCampaignPage />
                    </PrivateRoute>
                    <PrivateRoute exact path="/campaigns/status/:status">
                        <CampaignList />
                    </PrivateRoute>
                    <PrivateRoute
                        exact
                        path="/campaign-proposals/status/:status">
                        <CampaignProposalsList />
                    </PrivateRoute>
                    <PrivateRoute exact path="/management">
                        <Management />
                    </PrivateRoute>
                    <Route
                        path="/screen/:operation/:campaignid/:token"
                        component={ScreenApproval}
                    />
                    <Route
                        path="/screen/creative"
                        component={CreativityPublicView}
                    />
                    <PrivateRoute exact path="/proposal/:id">
                        <NewProposal />
                    </PrivateRoute>
                    <PrivateRoute exact path="/proposal/brief/:id">
                        <ProposalBrief />
                    </PrivateRoute>
                    <Route path="*" component={NotFoundPage} />
                </Switch>
            </SnackbarProvider>
        </>
    );
}

export default App;
